import { createEvent, createStore } from 'effector';

import { TItemsWithPagination, TSortingItems } from '~utils';

type TStore = Record<
  string,
  { data: TItemsWithPagination | null; page: number; sort: TSortingItems }
>;

export const $currentDataWithoutFiltersStore = createStore<TStore>({});

export const saveCurrentDataWithoutFilters = createEvent<{
  data: TItemsWithPagination | null;
  path: string;
  page?: number;
}>();
export const removeCurrentDataWithoutFilters = createEvent<string>();
export const saveCurrentPaginationPageWithoutFilters = createEvent<{
  path: string;
  page: number;
}>();
export const saveCurrentSortWithoutFilters = createEvent<{
  path: string;
  sort: TSortingItems;
}>();
